import {useInferableTranslation} from '@di-shared/features/common/useInferableTranslation';
import {useSuspenseQuery} from '@tanstack/react-query';
import {getQueryKey} from '@shared/queryKeyMap';
import {diApi} from '@di-shared/api/di';
import {getIsLowBatteryChargeBannerVisible, getIsMonthlyChargeRemindeBannerVisible} from '@di-shared/features/home/kr/ev-battery/util';
import {parseDateWithFormat} from '@shared/dateUtils';
import React, {Suspense} from 'react';
import {ErrorBoundary} from 'react-error-boundary';

interface EvBatteryMonitorBannerProps {
  vin: string;
  puid: string;
}

function ChargingEventNotification(props: EvBatteryMonitorBannerProps) {
  return (
    <ErrorBoundary fallback={<></>}>
      <Suspense fallback={<></>}>
        <Inner {...props} />
      </Suspense>
    </ErrorBoundary>
  );
}

function Inner({vin, puid}: EvBatteryMonitorBannerProps) {
  const {t} = useInferableTranslation();
  const {
    data: {data},
  } = useSuspenseQuery({
    queryKey: [getQueryKey(diApi.evBatteryController.getEvBatteryStatus), vin, puid],
    queryFn: () => diApi.evBatteryController.getEvBatteryStatus({vin, puid}),
  });
  const isLowBatteryChargeBannerVisible = getIsLowBatteryChargeBannerVisible(data.soc);
  const isMonthlyChargeRemindeBannerVisible = getIsMonthlyChargeRemindeBannerVisible(parseDateWithFormat(data.lastChargedDate));
  if (isLowBatteryChargeBannerVisible) {
    return (
      <div className="guide_banner battery_guide">
        <span className="ic ic_filled_caution_16px" />
        <p
          className="guide_banner_title"
          style={{whiteSpace: 'pre-wrap'}}
        >
          {t('T30451')}
        </p>
      </div>
    );
  }
  if (isMonthlyChargeRemindeBannerVisible) {
    return (
      <div className="guide_banner battery_guide">
        <span className="ic ic_filled_caution_16px" />
        <p
          className="guide_banner_title"
          style={{whiteSpace: 'pre-wrap'}}
        >
          {t('T30452')}
        </p>
      </div>
    );
  }
  return <></>;
}

export default ChargingEventNotification;
